import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PaymentOrdersService {
  private url = environment.api;

  constructor(private http: HttpClient) {}

  /**
   * Calls GET /api/v1/payment-orders/get-by-correlative/{correlative}/{serviceCenterId}/{customerId}
   * Uses values from the current environment: orderCorrelative, serviceCenterId and customerId.
   */
  getByCorrelative(correlative?: string): Observable<any> {
    const env: any = environment as any;
    console.log(
      '[PaymentOrdersService] environment snapshot (for fallback):',
      env
    );
    const corr =
      correlative ??
      localStorage.getItem('orderCorrelative') ??
      env.orderCorrelative ??
      '';
    const serviceCenterId =
      localStorage.getItem('scid') ?? env.serviceCenterId ?? '';
    const customerId = localStorage.getItem('cid') ?? env.customerId ?? '';

    const endpoint = `${this.url}/api/v1/payment-orders/get-by-correlative/${corr}/${serviceCenterId}/${customerId}`;
    console.log('[PaymentOrdersService] getByCorrelative called with:', {
      correlative: corr,
      serviceCenterId,
      customerId,
      endpoint,
    });

    return new Observable((observer) => {
      this.http.get(endpoint).subscribe(
        (res) => {
          console.log('[PaymentOrdersService] response:', res);
          observer.next(res);
          observer.complete();
        },
        (err) => {
          console.error('[PaymentOrdersService] error:', err);
          observer.error(err);
        }
      );
    });
  }

  public PayOrdersByTransfer(
    paymentOrdersId: string,
    data: any
  ): Observable<any> {
    let urlbase = `${environment.api}/api/v1/payment/pay-orders-by-transfer/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }

  public PayOrdersByTransferWithFile(
    paymentOrdersId: string,
    data: any
  ): Observable<any> {
    let urlbase = `${environment.api}/api/v1/payment/pay-orders-by-transfer-with-file/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }

  public PaymentIntentPaymentOrders(data: any): Observable<any> {
    let urlbase = `${environment.api}/api/payment-stripe/payment-button`;
    return this.http.post<any>(urlbase, data);
  }

  public PayOrdersByCash(paymentOrdersId: string, data: any): Observable<any> {
    let urlbase = `${environment.api}/api/v1/cash-payment/pay-orders-by-cash/${paymentOrdersId}`;
    return this.http.post<any>(urlbase, data);
  }
}
